const doc = [({"reverse_charge":"O destinatário do serviço é responsável pelo IVA de acordo com o mecanismo de auto-liquidação."})];
module.exports = doc.length <= 1 ? doc[0] : doc;